import React from 'react';
import { Route } from 'react-router-dom';
import AlumniPortal from '@/pages/alumni-portal/AlumniPortal';

export const alumniPortalRoutes = (
  <React.Fragment>
    <Route path="alumni-portal" element={<AlumniPortal />} />
    <Route path="alumni-portal/login" element={<AlumniPortal />} />
    <Route path="alumni-portal/register" element={<AlumniPortal />} />
  </React.Fragment>
);
